<template>
    <div :class="[{ 'opacity-background': show }]">
        <header>
            <div class="navbar-fixed">
                <nav class="header-contractor-mobile">
                    <div @click="$emit('show')" :class="['nav-icon', { open: show }]">
                        <div></div>
                    </div>
                    <a
                        @click="$emit('push-route', { url: 'LandingPage', solo: false })"
                        class="brand-logo-contractor-guest-mobile"
                    >
                        <img src="@/assets/images/engelink_logo.svg" class="center-element" alt="Engelink" />
                    </a>
                </nav>
            </div>
            <div :class="['side-bar-contractor-guest-mobile', { show: show }]">
                <ul>
                    <div class="btn-contractor-guest-mobile mt-42">
                        <a
                            @click="$emit('push-route', { url: 'Signup', solo: false })"
                            class="waves-effect waves-light btn btn-signup-contractor-guest-signup contractor-guest-btn-mobile"
                            v-if="!hasKey"
                            >Cadastre-se</a
                        >
                    </div>
                    <div class="btn-contractor-guest-mobile mb-25">
                        <a
                            @click="$emit('push-route', { url: 'Login', solo: false })"
                            class="waves-effect waves-light btn btn-signup-contractor-guest contractor-guest-btn-mobile"
                            >{{ hasKey ? 'Painel' : 'Entrar' }}</a
                        >
                    </div>
                    <li>
                        <a @click="$emit('push-route', { url: 'ContactUs', solo: false })">
                            <span class="title-mobile">Fale conosco</span>
                        </a>
                    </li>

                    <li>
                        <a @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true })">
                            <span class="title-mobile">Materiais</span>
                        </a>
                    </li>

                    <li>
                        <a @click="$emit('push-route', { url: 'CondoTechsLandingpage', solo: false })">
                            <span class="title-mobile">Condotechs</span>
                        </a>
                    </li>
                    <li>
                        <a @click="$emit('push-route', { url: 'https://condo.news/', solo: true })">
                            <span class="title-mobile">CondoNews</span>
                        </a>
                    </li>
                    <li>
                        <a @click="$emit('push-route', { url: 'https://blog.engelink.com.br/', solo: true })">
                            <span class="title-mobile">Blog</span>
                        </a>
                    </li>
                    <li>
                        <a @click="$emit('push-route', { url: 'NetworkSuppliers', solo: false })">
                            <span class="title-mobile">Guia de Fornecedores</span>
                        </a>
                    </li>
                    <li>
                        <a @click="$emit('push-route', { url: 'CompetitionDashboardGuest', solo: false })">
                            <span class="title-mobile supplier-guest-mobile-title">Sou fornecedor</span>
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    </div>
</template>

<script>
// Módulos
import { mapActions, mapState } from 'vuex';
export default {
    name: 'HeaderContractorGuestMobile',
    props: {
        show: Boolean
    },
    methods: {
        ...mapActions('user', ['logout'])
    },
    computed: {
        ...mapState('user', ['user']),
        hasKey() {
            return this.user.key ? this.user.key : false;
        }
    }
};
</script>

<style lang="scss">
li {
    list-style-type: none;
}
.header-contractor-mobile {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    z-index: 999 !important;
    box-shadow: 0px 3px 6px #00000029;
}
nav .brand-logo-contractor-guest-mobile {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    height: 54px;
    justify-content: center;
    width: 150px;
}
nav .brand-logo-contractor-guest-mobile img {
    max-height: 40px;
    max-width: 150px;
}
/* // Tracinho de cima */
.nav-icon:before {
    width: 35px;
}
/* // Tracinho do meio */
.nav-icon {
    /* // margin: 1em; */
    left: 0;
    position: fixed;
    width: 30px;
    margin-left: 25px;
    align-self: center;
}
/* // Tracinho de baixo */
.nav-icon:after {
    width: 25px;
}
.nav-icon:after,
.nav-icon:before,
.nav-icon div {
    background-color: #003f7e;
    border-radius: 3px;
    content: '';
    display: block;
    height: 4px;
    margin: 4px 0;
    transition: all 0.4s ease-in-out;
}
/* // largura quando o menu está aberto */
.nav-icon.open:after,
.nav-icon.open:before,
.nav-icon.open {
    width: 20px !important;
    padding-left: 0px !important;
}
.nav-icon.open:before {
    transform: translateY(12px) rotate(135deg);
}

.nav-icon.open:after {
    transform: translateY(-12px) rotate(-135deg);
}

.nav-icon.open div {
    transform: scale(0);
}
.side-bar-contractor-guest-mobile {
    text-align: justify;
    position: fixed;
    height: 100%;
    width: 0%;
    z-index: 9999 !important;
    background-color: #fff;
    color: #000;
    transition: 0.5s;
    overflow: hidden;
    box-shadow: black;
}
.side-bar-contractor-guest-mobile.show {
    box-shadow: inset 0px 3px 6px #00000029;
    width: 80%;
}
.side-bar-contractor-guest-mobile ul {
    /* // position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
}
.side-bar-contractor-guest-mobile ul li {
    position: relative;
    width: 100%;
    list-style: none;
}
.side-bar-contractor-guest-mobile ul li a .title-mobile {
    position: relative;
    display: block;
    padding: 0 10px;
    text-align: start;
    white-space: nowrap;
}
.side-bar-contractor-guest-mobile ul li a {
    position: relative;
    display: block;
    width: 100%;
    /* // display: flex; */
    text-decoration: none;
    padding: 13px 16px 13px 16px;
    text-decoration: none;
    font-size: 16px;
    color: #707070;
}
.side-bar-contractor-guest-mobile.show {
    width: 80%;
}
/* efeito de opacidade do menu de fornecedor na versão mobile */
.opacity-background {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    display: table;
    transition: 0.5s;
    overflow: hidden;
}
.btn-contractor-guest-mobile {
    display: flex;
    justify-content: flex-start;
    margin-top: 6px;
    margin-left: 25px;
}
.contractor-guest-btn-mobile {
    width: 90%;
}
.supplier-guest-mobile-title {
    color: #007bff;
    font-weight: 600;
}

.mb-25 {
    margin-bottom: 25px;
}

.mt-42 {
    margin-top: 42px;
}
</style>
